/* pause — storefront behaviour (v3.1).
   Custom elements, so the same file runs in the static preview and in the Shopify theme
   (elements re-initialise when the theme editor re-renders a section).
   With window.Shopify present the cart uses Shopify's AJAX Cart API; otherwise a demo cart. */
(() => {
  'use strict';
  if (window.__pauseLoaded) return; window.__pauseLoaded = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = ore => Math.round(ore / 100).toLocaleString('nb-NO').replace(/\s/g, ' ') + ' kr';
  const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };
  const onReady = f => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', f) : f();
  if (!document.documentElement.lang) document.documentElement.lang = 'nb';

  /* ---------------- header ---------------- */
  define('pause-header', class extends HTMLElement {
    connectedCallback() {
      const darks = () => $$('.dark, .final, .foot');
      this.on = () => { this.classList.toggle('is-stuck', scrollY > 8); const y = this.getBoundingClientRect().bottom - 2; this.classList.toggle('is-dark', darks().some(d => { const r = d.getBoundingClientRect(); return r.top <= y && r.bottom > y; })); };
      addEventListener('scroll', this.on, { passive: true }); this.on();
    }
    disconnectedCallback() { removeEventListener('scroll', this.on); }
  });

  /* ---------------- rotating app name in the headline ---------------- */
  define('pause-rotate', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.t);
      const words = (this.dataset.words || '').split('|').filter(Boolean);
      if (words.length < 2) return;
      const items = Array.from({ length: 7 }, (_, i) => {
        const el = document.createElement('span');
        el.className = 'rot__item';
        return { el, slot: i - 3 };
      });
      let selected = 0;
      const wordAt = n => words[((n % words.length) + words.length) % words.length];
      const render = (item, instant = false) => {
        const distance = Math.abs(item.slot);
        item.el.textContent = wordAt(selected + item.slot);
        item.el.style.transition = instant || reduce() ? 'none' : '';
        item.el.style.transform = `translate3d(0, ${item.slot * 1.12}em, 0) rotateX(${-item.slot * 34}deg) scale(${distance ? .86 : 1})`;
        item.el.style.opacity = distance === 0 ? '1' : distance === 1 ? '.25' : '0';
      };
      items.forEach(item => render(item, true));
      this.replaceChildren(...items.map(item => item.el));
      this.classList.add('rot--wheel');
      this.t = setInterval(() => {
        if (document.hidden) return;
        selected++;
        items.forEach(item => {
          item.slot--;
          const wrapped = item.slot < -3;
          if (wrapped) item.slot = 3;
          render(item, wrapped);
        });
      }, 2800);
    }
    disconnectedCallback() { clearInterval(this.t); }
  });

  /* ---------------- dayline illustration ---------------- */
  define('pause-dayline', class extends HTMLElement {
    connectedCallback() {
      const svg = $('svg', this); if (!svg || svg.dataset.done) return; svg.dataset.done = 1;
      const NS = 'http://www.w3.org/2000/svg', W = 1200, H = 60, span = 960, total = +(this.dataset.minutes || 321);
      let seed = 7; const rnd = () => (seed = (seed * 16807) % 2147483647, (seed - 1) / 2147483646);
      const sess = []; let sum = 0;
      while (sum < total) { const r = rnd(); let d = r < .62 ? 1 + Math.round(rnd() * 4) : r < .9 ? 6 + Math.round(rnd() * 10) : 18 + Math.round(rnd() * 26); d = Math.min(d, total - sum); sess.push(d); sum += d; }
      const w = sess.map(() => .6 + rnd() * 1.6), ws = w.reduce((a, b) => a + b, 0), free = span - total - 16;
      const g = document.createElementNS(NS, 'g');
      const bg = document.createElementNS(NS, 'rect'); bg.setAttribute('width', W); bg.setAttribute('height', H); bg.setAttribute('fill', 'rgba(18,18,17,.08)'); g.appendChild(bg);
      let t = 8; sess.forEach((d, i) => { const r = document.createElementNS(NS, 'rect'); r.setAttribute('x', (t * W / span).toFixed(2)); r.setAttribute('width', Math.max(d * W / span, 2).toFixed(2)); r.setAttribute('height', H); r.setAttribute('fill', '#121211'); g.appendChild(r); t += d + (w[i] / ws) * free; });
      svg.appendChild(g);
    }
  });

  /* ---------------- screen-time calculator (1–10 t) ---------------- */
  define('pause-calc', class extends HTMLElement {
    connectedCallback() {
      const r = $('input[type=range]', this); if (!r) return;
      const out = $('[data-mins-out]', this), q = s => $(`[data-${s}]`, this);
      const nf = n => n.toLocaleString('nb-NO').replace(/\s/g, ' ');
      const fmt = m => m % 60 ? `${Math.floor(m / 60)} t ${m % 60} min` : `${m / 60} t`;
      const upd = () => {
        const m = +r.value, yh = Math.round(m * 365 / 60);
        out.textContent = fmt(m);
        q('year').textContent = nf(yh);
        q('days').textContent = nf(Math.round(yh / 24));
        const life = m / 1440 * 50; q('life').textContent = `${life < 10 ? life.toFixed(1).replace('.', ',') : Math.round(life)} år`;
        r.setAttribute('aria-valuetext', `${fmt(m).replace(' t', ' timer')} om dagen`);
        r.style.setProperty('--p', ((m - r.min) / (r.max - r.min) * 100) + '%');
      };
      r.addEventListener('input', upd); upd();
    }
  });

  /* ---------------- gallery ---------------- */
  define('pause-gallery', class extends HTMLElement {
    connectedCallback() {
      const main = $('[data-gal-main]', this), cap = $('[data-gal-cap]', this), thumbs = $$('[data-src]', this); if (!main) return;
      thumbs.forEach(b => b.addEventListener('click', () => {
        thumbs.forEach(x => x.setAttribute('aria-current', x === b));
        main.style.opacity = 0;
        setTimeout(() => {
          if (b.dataset.srcset) main.srcset = b.dataset.srcset; else main.removeAttribute('srcset');
          main.src = b.dataset.src; main.alt = b.dataset.alt || ''; main.style.objectPosition = b.dataset.pos || '50% 50%';
          if (cap) cap.textContent = b.dataset.cap || '';
          const show = () => main.style.opacity = 1; main.complete ? show() : main.addEventListener('load', show, { once: true });
        }, reduce() ? 0 : 160);
      }));
    }
  });

  /* ---------------- delivery estimate (Europe/Oslo, Norwegian holidays) ---------------- */
  function easter(y) { const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1; return Date.UTC(y, mo - 1, da); }
  const DAY = 864e5;
  function holidays(y) {
    const e = easter(y), fixed = [[0, 1], [4, 1], [4, 17], [11, 24], [11, 25], [11, 26], [11, 31]].map(([m, d]) => Date.UTC(y, m, d));
    return new Set([...fixed, e - 3 * DAY, e - 2 * DAY, e + DAY, e + 39 * DAY, e + 50 * DAY]);
  }
  function osloNow() {
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Oslo', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false }).formatToParts(new Date()).map(x => [x.type, x.value]));
    return { day: Date.UTC(+p.year, +p.month - 1, +p.day), hour: +p.hour % 24 };
  }
  const isBiz = t => { const wd = new Date(t).getUTCDay(); return wd !== 0 && wd !== 6 && !holidays(new Date(t).getUTCFullYear()).has(t); };
  const addBiz = (t, n) => { while (n > 0) { t += DAY; if (isBiz(t)) n--; } return t; };
  define('pause-ship', class extends HTMLElement {
    connectedCallback() {
      try {
        const cutoff = +(this.dataset.cutoff || 15), min = +(this.dataset.min || 1), max = +(this.dataset.max || 3);
        const now = osloNow(), today = isBiz(now.day) && now.hour < cutoff;
        const ship = today ? now.day : addBiz(now.day, 1), a = addBiz(ship, min), b = addBiz(ship, max);
        const WD = ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'], MO = ['jan', 'feb', 'mars', 'april', 'mai', 'juni', 'juli', 'aug', 'sep', 'okt', 'nov', 'des'];
        const A = new Date(a), B = new Date(b), d = D => `${WD[D.getUTCDay()]} ${D.getUTCDate()}.`;
        const range = A.getUTCMonth() === B.getUTCMonth() ? `${d(A)}–${d(B)} ${MO[B.getUTCMonth()]}` : `${d(A)} ${MO[A.getUTCMonth()]}–${d(B)} ${MO[B.getUTCMonth()]}`;
        this.innerHTML = (today ? `Bestill før kl. ${cutoff}, så sendes den i dag. ` : 'Sendes neste virkedag. ') + `<b>I postkassen ${range}</b>`;
      } catch (e) { /* keep fallback */ }
    }
  });

  /* ---------------- sticky mobile buy bar ---------------- */
  define('pause-sticky', class extends HTMLElement {
    connectedCallback() {
      const cta = $('[data-hero-cta]'), hide = $$('[data-hide-sticky]'); if (!cta) return;
      const vis = new Map([[cta, true]]); hide.forEach(h => vis.set(h, false));
      const link = $('a', this);
      const upd = () => { const on = !vis.get(cta) && !hide.some(h => vis.get(h)); this.classList.toggle('is-on', on); this.setAttribute('aria-hidden', !on); if (link) link.tabIndex = on ? 0 : -1; };
      this.io = new IntersectionObserver(es => { es.forEach(e => vis.set(e.target, e.target === cta ? (e.isIntersecting || e.boundingClientRect.top > 0) : e.isIntersecting)); upd(); });
      [cta, ...hide].forEach(x => this.io.observe(x));
    }
    disconnectedCallback() { this.io && this.io.disconnect(); }
  });

  /* ---------------- reveal on scroll ---------------- */
  const rio = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); rio.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' }) : null;
  const scan = () => $$('.rv:not(.in)').forEach(el => rio ? rio.observe(el) : el.classList.add('in'));
  onReady(scan); document.addEventListener('shopify:section:load', scan);

  /* ---------------- running timer in the app mockup ---------------- */
  onReady(() => $$('[data-clock]').forEach(el => {
    if (el.dataset.run) return; el.dataset.run = 1; let s = 754;
    const f = () => { el.textContent = [s / 3600, s % 3600 / 60, s % 60].map(v => String(Math.floor(v)).padStart(2, '0')).join(':'); s++; };
    f(); if (!reduce()) setInterval(f, 1000);
  }));
})();

/* Production commerce: Shopify is the only source of price, availability and cart state. */
(() => {
'use strict';
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
const root=window.Shopify?.routes?.root || '/';
const money=n=>new Intl.NumberFormat('nb-NO',{style:'currency',currency:window.Shopify?.currency?.active||'NOK',maximumFractionDigits:2}).format(n/100);
let busy=false;
function announce(message){const el=$('[data-toast]');if(el){el.textContent=message;el.classList.add('is-on');clearTimeout(el.timer);el.timer=setTimeout(()=>el.classList.remove('is-on'),7000);}}
async function request(path,body){
 const response=await fetch(root+path,{method:body?'POST':'GET',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{}),credentials:'same-origin'});
 let data;try{data=await response.json();}catch{throw Error('Kunne ikke lese handlekurven. Åpne handlekurven på nytt.');}
 if(!response.ok)throw Error(data.description||'Kunne ikke oppdatere handlekurven. Prøv igjen.');
 return data;
}
async function refresh(){const cart=await request('cart.js');document.dispatchEvent(new CustomEvent('pause:cart',{detail:cart}));return cart;}
async function mutate(fn){
 if(busy)return;busy=true;
 const controls=$$('pause-product button, pause-cart button, pause-product input');
 const wasDisabled=controls.map(x=>x.disabled); controls.forEach(x=>x.disabled=true);
 try{await fn();}catch(e){announce(e.message||'Noe gikk galt. Prøv igjen.');}
 finally{busy=false;controls.forEach((x,i)=>x.disabled=wasDisabled[i]);$$('pause-product').forEach(x=>x.sync?.());const c=$('pause-cart');if(c)c.checkout.disabled=!c.cart?.items?.length;}
}
class Product extends HTMLElement {
 connectedCallback(){
 if(this.ready)return;this.ready=true;this.form=$('form',this);this.button=$('[data-add]',this);
 this.inputs=$$('input[name="id"]',this);this.inputs.forEach(x=>x.addEventListener('change',()=>this.sync()));
 this.form?.addEventListener('submit',event=>{
 if(!this.button)return;event.preventDefault();const selected=this.selected();if(!selected||selected.disabled)return;
 mutate(async()=>{await request('cart/add.js',{items:[{id:selected.value,quantity:1}]});await refresh();$('pause-cart')?.open();});
 });this.sync();
 }
 selected(){return this.inputs.find(x=>x.checked&&!x.disabled)||this.inputs.find(x=>!x.disabled);}
 sync(){const s=this.selected();if(s){s.checked=true;$$('[data-price]:not(input),[data-add-price]',this).forEach(x=>x.textContent=money(+s.dataset.price));}if(this.button)this.button.disabled=busy||!s;}
}
class Cart extends HTMLElement {
 connectedCallback(){
 if(this.ready)return;this.ready=true;this.panel=$('[data-cart-panel]',this);this.body=$('[data-cart-body]',this);this.checkout=$('[data-checkout]',this);
 $('[data-close-cart]',this).addEventListener('click',()=>this.close());$('[data-scrim]',this).addEventListener('click',()=>this.close());
 this.checkout.addEventListener('click',()=>{if(!busy&&this.cart?.items.length)location.assign(root+'checkout');});
 document.addEventListener('pause:cart',e=>this.render(e.detail));
 document.addEventListener('click',e=>{if(e.target.closest('[data-open-cart]')){e.preventDefault();this.open();refresh().catch(()=>announce('Kunne ikke laste handlekurven. Prøv igjen, eller gå til '+root+'cart'));}});
 this.addEventListener('keydown',e=>{if(e.key==='Escape')this.close();if(e.key==='Tab'){const list=$$('button:not(:disabled),a[href],input:not(:disabled)',this);const first=list[0],last=list.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}}});
 refresh().catch(()=>{});
 }
 open(){this.previous=document.activeElement;this.inert=false;this.classList.add('is-on');this.setAttribute('aria-hidden','false');this.panel.setAttribute('aria-hidden','false');this.previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';this.background=$$('body > *').filter(x=>x!==this&&!x.contains(this)&&x.tagName!=='SCRIPT'&&!x.matches('[data-toast]')).map(x=>[x,x.inert]);this.background.forEach(([x])=>x.inert=true);$('[data-close-cart]',this).focus();}
 close(){this.classList.remove('is-on');this.setAttribute('aria-hidden','true');this.panel.setAttribute('aria-hidden','true');this.inert=true;document.documentElement.style.overflow=this.previousOverflow||'';this.background?.forEach(([x,value])=>x.inert=value);this.previous?.focus();}
 render(cart){
 this.cart=cart;this.body.replaceChildren();
 if(!cart.items.length){const p=document.createElement('p');p.className='cart__empty';p.textContent='Handlekurven er tom.';this.body.append(p);}
 for(const item of cart.items){
 const line=document.createElement('div');line.className='line';
 line.innerHTML='<div class="line__img"><img alt=""></div><div><b></b><small></small><div class="qty"><button type="button" aria-label="Færre pakker">−</button><span></span><button type="button" aria-label="Flere pakker">+</button></div><button type="button" class="remove">Fjern</button></div><span class="line__p"></span>';
 // Never interpolate API text into HTML.
 $('b',line).textContent=item.product_title;$('small',line).textContent=item.variant_title||'';
 const img=$('img',line);const src=item.image||this.dataset.thumb;try{const u=new URL(src,location.href);if(u.protocol==='https:'||u.origin===location.origin)img.src=u.href;}catch{img.remove();}
 $('.qty span',line).textContent=item.quantity;$('.line__p',line).textContent=money(item.final_line_price);
 const update=q=>mutate(async()=>{await request('cart/change.js',{id:item.key,quantity:q});await refresh();});
 const [minus,plus]=$$('.qty button',line);minus.addEventListener('click',()=>update(item.quantity-1));plus.addEventListener('click',()=>update(item.quantity+1));$('.remove',line).addEventListener('click',()=>update(0));this.body.append(line);
 }
 $('[data-cart-total]',this).textContent=money(cart.total_price);this.checkout.disabled=busy||!cart.items.length;
 $$('[data-cart-count]').forEach(x=>{x.hidden=!cart.item_count;x.textContent=cart.item_count;});
 }
}
customElements.define('pause-product',Product);customElements.define('pause-cart',Cart);
})();
